import { useLocalObservable } from 'mobx-react-lite';
import { runInAction } from 'mobx';

export const financeTabs = [
  { key: 'pays', label: 'Отчёт по платежам' },
  { key: 'received', label: 'Отчёт по абонентской плате' },
] as const;

export type FinanceTab = (typeof financeTabs)[number]['key'];

export function useFinancesReportController() {
  const store = useLocalObservable(() => ({
    activeTab: 'pays' as FinanceTab,
  }));

  function setActiveTab(tab: FinanceTab) {
    runInAction(() => {
      store.activeTab = tab;
    });
  }

  return { store, setActiveTab };
}
